import React from 'react';
import Icon from '@/components/ui/AppIcon';
import SEOHeading from '@/components/common/SEOHeading';

interface PhilosophyPoint {
  id: number;
  title: string;
  description: string;
  icon: string;
}

interface BreedingPhilosophyProps {
  philosophyPoints: PhilosophyPoint[];
}

const BreedingPhilosophy = ({ philosophyPoints }: BreedingPhilosophyProps) => {
  return (
    <section className="mb-16">
      <div className="mb-8 text-center">
        <SEOHeading level={2} className="mb-3">
          How We Approach Breeding
        </SEOHeading>
        <p className="text-muted-foreground">
          We're deeply committed to excellence in health, temperament, and maintaining the highest breed standards
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {philosophyPoints.map((point) => (
          <div
            key={point.id}
            className="rounded-xl border border-border bg-card p-6 shadow-warm transition-smooth hover:border-primary/30 hover:shadow-warm-md"
          >
            <div className="mb-4 flex items-start gap-4">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-accent/10">
                <Icon
                  name={point.icon as any}
                  size={24}
                  variant="solid"
                  className="text-accent"
                />
              </div>
              <div>
                <h3 className="mb-2 font-heading text-xl font-semibold text-foreground">
                  {point.title}
                </h3>
                <p className="leading-relaxed text-muted-foreground">
                  {point.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BreedingPhilosophy;